<div class="surface-card">
  <div class="surface-card-header">
    {{ organisationName }} {{ 'seahorseModules.seahorseModules' | translate }}
  </div>
  <sh-table
    tableId="seahorse-modules"
    [columns]="columns"
    [rows]="rows"
    [loading]="isLoading"
    rowOpenMode="navigate"
    (rowOpen)="openModule($event)"
  ></sh-table>
</div>
